// extracted by mini-css-extract-plugin
export default {"title-row":"EntityDetails__title-row__ed13aa74c7eb4edfafcc","titleRow":"EntityDetails__title-row__ed13aa74c7eb4edfafcc"};